import { Component, OnInit } from '@angular/core';
import { DynamicContentByTenant } from '@bo-client/shared/constants/dynamicContentByTenant';
import { ConfigService } from '@bo-client/config/config.service';
import { DataShareService } from '@bo-client/shared/services/data-share.service';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss']
})
export class TermsConditionsComponent implements OnInit {
  public dynamicContentByTenant = DynamicContentByTenant;
  public buildInfo: any;

  constructor(private configService: ConfigService, private dataShareService: DataShareService) {
    // Empty
  }

  get content() {
    return this.dataShareService.tenantConfig.common?.termsAndConditions || '';
  }

  ngOnInit(): void {
    this.buildInfo = this.configService.getSettings('buildInfo');
  }
}
